import { keccak256 } from 'viem';
import { bytesToHex, hexToBytes } from '@txviz/core';

/**
 * Hash serialized Ethereum transaction bytes using keccak256.
 *
 * For regular transactions: keccak256(serialized_unsigned_tx)
 * This produces the 32-byte hash that gets signed with the private key.
 */
export function hashEthereumTransaction(serialized: Uint8Array): Uint8Array {
  const hex = bytesToHex(serialized) as `0x${string}`;
  const hashHex = keccak256(hex);
  return hexToBytes(hashHex);
}
